import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { useState as r, useCallback as t, useEffect as e } from "react";
import n from "@mui/icons-material/Close";
import a from "@mui/icons-material/InfoRounded";
import m from "@mui/icons-material/PlaylistAddCheckCircleRounded";
import l from "@mui/icons-material/WarningAmber";
import { SvgIcon as c, Typography as s, IconButton as p } from "@mui/joy";
import u from "@mui/joy/List";
import d from "@mui/joy/ListItem";
import f from "@mui/joy/Snackbar";
import x from "@mui/joy/Stack";
const h = { danger: a, success: m, warning: l, neutral: a, primary: a }, y = ({ autoHideDuration: a2 = 3e4, type: m2, message: l2, notificationTitle: y2 = "Зверніть увагу!", id: g, icon: b, button: v = null, onClose: j }) => {
  const [S, k] = r(true), z = b || h[m2], C = t(() => {
    k(false), j(g);
  }, [g, j]);
  return e(() => {
    null !== a2 && setTimeout(() => {
      C();
    }, a2);
  }, [a2, C]), i(f, { autoHideDuration: a2, variant: "soft", color: m2, open: S, anchorOrigin: { vertical: "bottom", horizontal: "right" }, sx: { flexDirection: "row", alignItems: l2 ? "flex-start" : "center", gap: 1, p: 1.5, pr: 0.75, position: "relative", "&.MuiSnackbar-colorPrimary": { bgcolor: "primary.50", ".MuiIconButton-colorPrimary": { bgcolor: "primary.50", "&:hover": { bgcolor: "primary.100" } } } }, children: [o(c, { component: z, inheritViewBox: true, sx: { path: { fill: "inherit" }, fontSize: 24 } }), i(x, { sx: { flex: 1, position: "relative" }, children: [!!y2 && o(s, { level: "body-md", fontWeight: "bold", sx: { color: "inherit" }, children: y2 }), o(x, { sx: { fontSize: "14px" }, children: Array.isArray(l2) ? (A = l2, o(u, { sx: { pl: "32px", fontSize: "14px", padding: 0 }, children: A.map((i2, r2) => o(d, { sx: { padding: 0 }, children: i2 }, r2)) })) : l2 })] }), v, o(p, { onClick: () => C(), size: "sm", variant: "soft", color: m2, sx: l2 ? { position: "relative", top: "-6px", marginLeft: "auto" } : {}, children: o(n, {}) })] });
  var A;
};
export {
  y as Notification
};
//# sourceMappingURL=Notification.js.map
